import type { ISection } from 'src/types/menu.types';

export const getCrossSectionDuplicateItemIds = (sections: ISection[]): ReadonlySet<string> => {
  const seen = new Set<string>();
  const duplicated = new Set<string>();

  sections.forEach(({ items }) =>
    new Set(items.map(({ itemId }) => itemId)).forEach((itemId) => {
      if (seen.has(itemId)) duplicated.add(itemId);
      seen.add(itemId);
    }),
  );

  return duplicated;
};
